import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoginService} from "@netfoundry-ui/shared/authorization";
import {defer} from "lodash";

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent implements OnInit, OnDestroy {

  constructor(public loginService: LoginService) {
    this.loginService.loginProcessing = true;
  }

  ngOnInit() {
    this.loginService.loginProcessing = true;
  }

  ngOnDestroy() {
    defer(() => {
      this.loginService.loginProcessing = false;
    });
  }
}
